/* Hidden span for measuring text width */
.measure-span {
    position: absolute;
    visibility: hidden;
    white-space: pre;
    font-family: 'IBM Plex Sans';
    font-size: var(--font-small);
    line-height: 17px;
    pointer-events: none;
}

.prompt-box-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    border-radius: 12px;
    border: 1px solid var(--ai-purple-lt);
    background: var(--white);
    box-sizing: border-box;
    padding-right: 10px;
}

.prompt-box-container:hover {
    box-shadow: var(--ai-purple-box-shadow);
    border: 1px solid var(--ai-purple-pink-md);
}

.prompt-box-container:focus-within {
    border: 1px solid var(--ai-purple-lt);
}

/* Stacked: submit button moves to its own row */
.prompt-box-container--stacked {
    flex-direction: column;
    align-items: stretch;
    padding-right: 0;
}

.prompt-box-textarea {
    resize: none;
    overflow: auto;
    outline: none;
    flex: 1 1 auto;
    width: 100%;
    max-height: 150px;
    border: none;
    background: transparent;
    color: var(--grey);
    box-sizing: border-box;

    /* body small */
    font-family: 'IBM Plex Sans';
    font-size: var(--font-small);
    line-height: 17px;

    padding: 10px;

    scrollbar-color: var(--grey-xlt) transparent;
}

.prompt-box-send-button {
    width: 40px;
    height: 30px;
    border-radius: 4px;
    background: var(--ai-purple-primary);
}

.prompt-box-container--stacked .prompt-box-send-button {
    align-self: flex-end;
    margin: 0 10px 8px 0;
}

/* Disabled state */
.prompt-box-container--disabled {
    opacity: 0.5;
    pointer-events: none;
}

.prompt-box-container--disabled:hover {
    box-shadow: none;
    border: 1px solid var(--ai-purple-lt);
}

.prompt-box-textarea:disabled {
    cursor: not-allowed;
}

.prompt-box-send-button-container {
    pointer-events: auto;
}
